import { useMemo } from 'react'
import useNftsForOwner from 'src/common/queries/useNftsForOwner'
import useConfig from 'src/config/hooks/useConfig'

const useOwnedCarbonTokens = (accountAddress: string | undefined) => {
  const { tokensAddresses } = useConfig()

  const {
    data: ownedCarbonTokens,
    isLoading: ownedCarbonLoading,
    ...rest
  } = useNftsForOwner(accountAddress, [tokensAddresses.vicc || ''])

  return useMemo(
    () => ({
      ownedCarbonTokens: ownedCarbonTokens?.nfts || [],
      total: ownedCarbonTokens?.total || 0,
      loading: ownedCarbonLoading,
      ...rest,
    }),
    [ownedCarbonTokens, ownedCarbonLoading, rest]
  )
}

export default useOwnedCarbonTokens
